// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path fill-rule="evenodd" d="M12 5C9.41 5 7.01 5.47 5.23 6.26 4.34 6.66 3.56 7.15 2.98 7.76 2.4 8.36 2 9.12 2 10V14C2 14.88 2.4 15.64 2.98 16.25 3.55 16.85 4.34 17.35 5.23 17.75 7.01 18.54 9.41 19 12 19S16.99 18.53 18.77 17.74C19.66 17.34 20.44 16.85 21.02 16.24 21.6 15.63 22 14.87 22 13.99V9.99C22 9.11 21.6 8.35 21.02 7.74 20.45 7.14 19.66 6.64 18.77 6.24 16.99 5.46 14.59 5 12 5M20 13.08C19.62 13.33 19.21 13.55 18.77 13.74 16.99 14.54 14.59 15 12 15S7.01 14.53 5.23 13.74A9 9 0 0 1 4 13.08V14C4 14.23 4.1 14.52 4.43 14.87 4.77 15.22 5.3 15.59 6.04 15.92 7.52 16.57 9.62 17 12 17S16.48 16.57 17.96 15.92C18.7 15.59 19.23 15.23 19.57 14.87 19.9 14.52 20 14.23 20 14Z" clip-rule="evenodd"/>';

/** Dollar Coin (commerce). */
const icon: IconData = {
  id: "coin",
  name: "Dollar Coin",
  category: "commerce",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-width="2" d="M21 10C21 12.21 16.97 14 12 14S3 12.21 3 10M21 10C21 7.79 16.97 6 12 6S3 7.79 3 10M21 10V14C21 16.21 16.97 18 12 18S3 16.21 3 14V10"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M11.96 5L13.95 5.09 15.74 5.34 17.38 5.74 18.84 6.29 20.1 6.99 21.11 7.87 21.64 8.62 21.79 8.97 22 10 21.98 14.22 21.79 15.03 21.64 15.38 20.93 16.33 19.94 17.12 18.71 17.77 17.27 18.29 15.64 18.68 13.86 18.92 11.96 19 10.05 18.91 8.26 18.66 6.62 18.26 5.16 17.71 3.9 17.01 2.89 16.13 2.36 15.38 2.21 15.03 2 14 2.02 9.78 2.21 8.97 2.36 8.62 3.07 7.67 4.06 6.88 5.29 6.23 6.73 5.71 8.36 5.32 10.14 5.08Z"/></g><path fill="none" stroke="currentColor" stroke-width="2" d="M21 10C21 12.21 16.97 14 12 14S3 12.21 3 10M21 10C21 7.79 16.97 6 12 6S3 7.79 3 10M21 10V14C21 16.21 16.97 18 12 18S3 16.21 3 14V10"/>',
    },
  },
  animation: () => import("../animations/coin.js"),
};

export default icon;
